(function(){
function initTicket(root){
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var code = root.dataset.code || 'LAUNCH15';
  var foil = root.querySelector('.st-foil'), ctx = foil.getContext('2d');
  var win = foil.parentElement, ticket = root.querySelector('.st-ticket'), actions = root.querySelector('.st-actions');
  var hint = root.querySelector('.st-hint'), again = root.querySelector('.st-again'), reveal = root.querySelector('.st-reveal');
  var done = false, last = null, moves = 0, down = false;
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var headFont = getComputedStyle(root).getPropertyValue('--font-heading-family') || 'sans-serif';

  function paintFoil(){
    var w = win.clientWidth, h = win.clientHeight;
    foil.width = Math.round(w*dpr); foil.height = Math.round(h*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0); ctx.globalCompositeOperation = 'source-over';
    var g = ctx.createLinearGradient(0,0,w,h);
    g.addColorStop(0,'#cfd3d8'); g.addColorStop(.25,'#f2f4f6'); g.addColorStop(.45,'#c9ced6');
    g.addColorStop(.6,'#e7e1f0'); g.addColorStop(.75,'#d5e9ec'); g.addColorStop(1,'#bfc4cb');
    ctx.fillStyle = g; ctx.fillRect(0,0,w,h);
    for (var i=0;i<w*h/45;i++){ ctx.fillStyle = 'rgba(255,255,255,'+(Math.random()*.55)+')'; ctx.fillRect(Math.random()*w, Math.random()*h, 1.2, 1.2); }
    for (var j=0;j<w*h/120;j++){ ctx.fillStyle = 'rgba(90,96,110,'+(Math.random()*.25)+')'; ctx.fillRect(Math.random()*w, Math.random()*h, 1, 1); }
    ctx.save(); ctx.translate(w/2,h/2); ctx.rotate(-0.18);
    ctx.font = '700 15px ' + headFont; ctx.fillStyle = 'rgba(70,74,84,.16)'; ctx.textAlign = 'center';
    for (var y=-h; y<h; y+=26){ for (var x=-w; x<w; x+=72){ ctx.fillText('95TIL', x + ((y/26)%2?36:0), y); } }
    ctx.restore();
    ctx.fillStyle = 'rgba(40,42,48,.82)'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = '700 22px ' + headFont; ctx.fillText('SCRATCH HERE', w/2, h/2 - 6);
    ctx.font = '600 11px sans-serif'; ctx.fillStyle = 'rgba(40,42,48,.6)'; ctx.fillText('✦  REVEAL YOUR LAUNCH CODE  ✦', w/2, h/2 + 18);
  }
  function scratch(x,y){
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 34;
    ctx.beginPath();
    if (last){ ctx.moveTo(last.x,last.y); ctx.lineTo(x,y); ctx.stroke(); } else { ctx.arc(x,y,17,0,Math.PI*2); ctx.fill(); }
    last = {x:x,y:y};
    if (++moves % 6 === 0) check();
  }
  function cleared(){
    var d = ctx.getImageData(0,0,foil.width,foil.height).data, clear = 0, n = 0;
    for (var i=3;i<d.length;i+=4*24){ n++; if (d[i] < 40) clear++; }
    return clear/n;
  }
  function check(){
    var c = cleared();
    hint.textContent = c < .15 ? 'Keep scratching…' : c < .35 ? 'Almost there…' : 'One more swipe…';
    if (c > .45) win_();
  }
  function pos(e){ var r = foil.getBoundingClientRect(); return { x:e.clientX - r.left, y:e.clientY - r.top }; }
  foil.addEventListener('pointerdown', function(e){ if (done) return; down = true; foil.setPointerCapture(e.pointerId); last = null; var p = pos(e); scratch(p.x,p.y); });
  foil.addEventListener('pointermove', function(e){ if (!down || done) return; var p = pos(e); scratch(p.x,p.y); });
  foil.addEventListener('pointerup', function(){ down = false; last = null; if (!done) check(); });
  foil.addEventListener('pointercancel', function(){ down = false; last = null; });

  function win_(){
    if (done) return; done = true;
    foil.classList.add('gone'); ticket.classList.add('won'); actions.classList.add('on');
    hint.textContent = 'Your code is unlocked.';
    again.hidden = false; reveal.hidden = true;
    if (navigator.vibrate) navigator.vibrate([12,40,18]);
    confetti();
  }
  reveal.addEventListener('click', win_);
  again.addEventListener('click', function(){
    done = false; foil.classList.remove('gone'); ticket.classList.remove('won'); actions.classList.remove('on');
    again.hidden = true; reveal.hidden = false; hint.textContent = 'Keep scratching…'; paintFoil();
  });

  root.querySelector('.st-copy').addEventListener('click', function(){
    var b = this;
    function ok(){ b.textContent = 'Copied ✓'; setTimeout(function(){ b.textContent = 'Copy code'; }, 1600); }
    function fallback(){ var r = document.createRange(); r.selectNodeContents(root.querySelector('.st-code')); var s = getSelection(); s.removeAllRanges(); s.addRange(r);
      try { document.execCommand('copy'); ok(); } catch(e){ b.textContent = 'Code selected, copy it'; } }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, fallback); else fallback();
  });

  function confetti(){
    if (reduce) return;
    var c = root.querySelector('.st-confetti'), x = c.getContext('2d');
    c.width = innerWidth*dpr; c.height = innerHeight*dpr; x.setTransform(dpr,0,0,dpr,0,0);
    var r = win.getBoundingClientRect(), cx = r.left + r.width/2, cy = r.top + r.height/2;
    var cols = ['#F47735','#F3EFE7','#e5546e','#3fb6a8','#e0b24a','#cfd3d8'], P = [];
    for (var i=0;i<140;i++){ var a = Math.random()*Math.PI*2, s = 4 + Math.random()*9;
      P.push({x:cx,y:cy,vx:Math.cos(a)*s,vy:Math.sin(a)*s - 5,r:Math.random()*Math.PI,vr:(Math.random()-.5)*.4,w:5+Math.random()*6,h:3+Math.random()*4,c:cols[i%cols.length],life:0}); }
    (function step(){
      x.clearRect(0,0,c.width,c.height); var alive = false;
      P.forEach(function(p){ p.life++; p.vy += .28; p.vx *= .985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        if (p.y < innerHeight + 20 && p.life < 160){ alive = true; x.save(); x.translate(p.x,p.y); x.rotate(p.r); x.globalAlpha = Math.max(0, 1 - p.life/160); x.fillStyle = p.c; x.fillRect(-p.w/2,-p.h/2,p.w,p.h); x.restore(); } });
      if (alive) requestAnimationFrame(step); else x.clearRect(0,0,c.width,c.height);
    })();
  }

  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function(){ if (!done) paintFoil(); });
  paintFoil();
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(function(){ if (!done) paintFoil(); }, 150); });
}
function initAll(){ document.querySelectorAll('[data-st-root]').forEach(initTicket); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
document.addEventListener('shopify:section:load', initAll);
})();
